export default __webpack_public_path__ + "static/tabs-hierarchy-do-0348cee2766fc8f2d432b842587648d4fb2794a597ba47d95bd39d6bc00e10b1.png";